import { Component, EventEmitter, Input, Output, model } from '@angular/core';

export type TabSide = 'left' | 'right';

@Component({
  selector: 'app-two-tabs-selector',
  templateUrl: './two-tabs-selector.component.html',
  styleUrls: ['./two-tabs-selector.component.scss'],
  standalone: false
})
export class TwoTabsSelectorComponent {

  @Input() leftLabel: string = 'Option 1';
  @Input() rightLabel: string = 'Option 2';
  @Input() leftCount?: number;
  @Input() rightCount?: number;
  @Input() customStyles?: Record<string, string>;
  @Input() customClass?: string;

  /** Tab activo. Lo puede fijar el padre con [selected]; el componente lo actualiza al tocar. */
  readonly selected = model<TabSide>('left');

  @Output() selectionChange = new EventEmitter<TabSide>();

  select(side: TabSide): void {
    this.selected.set(side);
    this.selectionChange.emit(side);
  }

}
